export type AutoExpandPriority = 'needs_input' | 'failed' | 'running' | 'none';
export type AutoExpandMode = 'single_target' | 'common_parent' | 'root_results' | 'none';

export type AutoExpandChildScope = {
  parent_step_run_id: string;
  child_index: number;
  attempt_number: number | null;
};

export type AutoExpandPlan = {
  priority: AutoExpandPriority;
  matching_result_count: number;
  hidden_root_result_count: number;
  mode: AutoExpandMode;
  step_run_ids_to_open: string[];
  child_scopes_to_open: AutoExpandChildScope[];
  common_parent_step_run_id: string | null;
  open_common_parent_children: boolean;
  child_results_skipped_for_size: boolean;
};

export const getAutoExpandScrollTargetStepRunId = (
  plan: AutoExpandPlan | null | undefined,
): string | undefined => {
  if (!plan) return undefined;

  if (plan.mode === 'common_parent') {
    return plan.common_parent_step_run_id ?? plan.step_run_ids_to_open.at(-1);
  }

  if (plan.mode === 'single_target') {
    return plan.step_run_ids_to_open.at(-1);
  }

  return plan.step_run_ids_to_open[0];
};
